import { defineStore } from 'pinia'
import { ref } from 'vue'

const REDIRECT_STORAGE_KEY = 'session-store-redirect'

export const useAidaSessionStore = defineStore('aidaSessionStore', () => {
  const aidaClientName = ref<string | undefined>(undefined)
  const aidaClientKey = ref<string | undefined>(undefined)
  const aidaSessionId = ref<string | undefined>(undefined)
  const aidaLibrary = ref<any | null>(null)
  const isAidaSessionExpired = ref<boolean>(false)

  function setAidaClient(aida: any, name: string | undefined, key: string | undefined): void {
    aidaLibrary.value = aida
    if (name && key) {
      aidaClientName.value = name
      aidaClientKey.value = key
    } else {
      console.log('aidaSessionStore - client data is empty.')
    }
  }

  // function getAidaLibrary():any | null {
  //   if (!aidaLibrary) console.error('AIDA Library is not initialized properly')
  //   return aidaLibrary.value
  // }

  function setAidaSessionIdIfNew(sessionId: string): void {
    // If the session id is not set at the start of the app
    if (aidaSessionId.value === undefined || aidaSessionId.value === '') {
      // Set the received session id
      aidaSessionId.value = sessionId
    } else if (aidaSessionId.value != sessionId) {
      // If the sessionId form the backend is new we need to inform the user and set the new id.
      setAidaSessionExpired(true)
      aidaSessionId.value = sessionId
    }
  }

  function setAidaSessionExpired(value: boolean) {
    isAidaSessionExpired.value = value
  }

  function authBase64(): string {
    return `Basic ${btoa(`${aidaClientName.value}:${aidaClientKey.value}`)}`
  }

  function saveForRedirect(): void {
    try {
      const payload = {
        aidaSessionId: aidaSessionId.value,
      }
      sessionStorage.setItem(REDIRECT_STORAGE_KEY, JSON.stringify(payload))
    } catch (e) {
      console.warn('Failed to save chat state for redirect', e)
    }
  }

  function restoreAfterRedirect(): void {
    try {
      const raw = sessionStorage.getItem(REDIRECT_STORAGE_KEY)
      if (!raw) return

      const parsed = JSON.parse(raw)

      aidaSessionId.value = parsed.aidaSessionId ?? ''
    } catch (e) {
      console.warn('Failed to restore session state after redirect', e)
    } finally {
      sessionStorage.removeItem(REDIRECT_STORAGE_KEY)
    }
  }

  return {
    setAidaClient,
    authBase64,
    setAidaSessionIdIfNew,
    setAidaSessionExpired,
    restoreAfterRedirect,
    saveForRedirect,
    aidaClientKey,
    aidaClientName,
    aidaSessionId,
    aidaLibrary,
    isAidaSessionExpired,
  }
})
